import { Listbox, Transition } from '@headlessui/react';
import { CheckIcon } from '@heroicons/react/outline';
import { useExecutiveSummaryState } from 'components/analytics/ExecutiveSummary/useExecutiveSummaryState';
import { ChevronDownIcon } from 'components/icons';
import { Fragment } from 'react';
import { useHistory } from 'react-router';
import { useQuery } from 'utils/useQuery';

export const TimeseriesMetricSelector = () => {
  const query = useQuery();
  const history = useHistory();

  const { selectedTimeseriesMetric, selectedCategoryMetrics } =
    useExecutiveSummaryState();

  const handleChange = (e: string) => {
    query.set('timeseries_metric', e);

    history.push({
      search: query.toString(),
    });
  };

  const hasTimeseriesMetrics = selectedCategoryMetrics.filter(
    (metric) => metric.hasTimeseries
  );

  return (
    <Listbox value={selectedTimeseriesMetric.id} onChange={handleChange}>
      <div className="relative">
        <Listbox.Button className="flex items-center px-4 py-2 space-x-1 text-base rounded-lg bg-segments-accent-green-3 ">
          <span className="font-bold text-segments-link">
            {selectedTimeseriesMetric.label}
          </span>
          <span>
            <ChevronDownIcon
              className="w-5 h-5 text-black"
              aria-hidden="true"
            />
          </span>
        </Listbox.Button>
        <Transition
          as={Fragment}
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Listbox.Options className="absolute z-20 w-auto py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm scrollbar-thin scrollbar-thumb-segments-darker-gray-75 scrollbar-thumb-rounded-md">
            {hasTimeseriesMetrics.map((option) => (
              <Listbox.Option
                key={option.id}
                className={({ active }) =>
                  `${active ? 'text-amber-900 bg-gray-100' : 'text-gray-900'}
                          cursor-default select-none relative py-2 pl-10 pr-8`
                }
                value={option.id}
              >
                {({ selected, active }) => (
                  <>
                    <span
                      className={`${
                        selected ? 'font-medium' : 'font-normal'
                      } block truncate`}
                    >
                      {option.label}
                    </span>
                    {selected ? (
                      <span className="absolute inset-y-0 left-0 flex items-center pl-3 ">
                        <CheckIcon className="w-5 h-5" aria-hidden="true" />
                      </span>
                    ) : null}
                  </>
                )}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Transition>
      </div>
    </Listbox>
  );
};
